export function eraseHoursMinutesSecondsAndMilliseconds(dateObj: Date) {
  dateObj.setHours(0);
  dateObj.setMinutes(0);
  dateObj.setSeconds(0);
  dateObj.setMilliseconds(0);

  return dateObj;
}
